import { Modal } from 'bootstrap'

/**
 * Look for links that target modals...
 */
const modalLinks = document.querySelectorAll('a[href^="#"]')
modalLinks.forEach(modalLink => {
  modalLink.addEventListener('click', (e) => {
    e.preventDefault()

    const href = modalLink.getAttribute('href')
    if (href && href != '#' && href != '#/') {

      const target = document.querySelector(href)
      if (target && target.classList.contains('modal')) {
        const modal = Modal.getOrCreateInstance(target)
        modal.show()
      }
    }
  })
})
